import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["loading", "submit", "saving", "notification", "message"];
  static values = { unsaved: Boolean };

  submit(event) {
    event.preventDefault();
    this.showLoading();

    const form = this.element;
    const formData = new FormData(form);

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
        this.hideLoading();
        this.showNotification("Settings saved successfully", "success");
        this.unsavedValue = false;
      })
      .catch(() => {
        this.hideLoading();
        this.showNotification("Failed to save settings", "error");
      });
  }

  showLoading() {
    this.loadingTarget.classList.remove("hidden");
    this.submitTarget.disabled = true;
    this.savingTarget.classList.remove("hidden");
  }

  hideLoading() {
    this.loadingTarget.classList.add("hidden");
    this.submitTarget.disabled = false;
    this.savingTarget.classList.add("hidden");
  }

  showNotification(message, type) {
    this.notificationTarget.classList.remove("hidden");
    this.notificationTarget.classList.add(
      type === "success"
        ? "bg-green-50 border-green-500"
        : "bg-red-50 border-red-500"
    );
    this.messageTarget.textContent = message;
    this.messageTarget.classList.add(
      type === "success" ? "text-green-800" : "text-red-800"
    );

    setTimeout(() => {
      this.notificationTarget.classList.add("hidden");
    }, 3000);
  }

  detectChanges() {
    this.unsavedValue = true;
  }

  checkUnsavedChanges(event) {
    if (this.unsavedValue) {
      event.preventDefault();
      event.returnValue = "";
    }
  }

  confirmCancel(event) {
    if (
      this.unsavedValue &&
      !confirm("You have unsaved changes. Are you sure you want to leave?")
    ) {
      event.preventDefault();
    }
  }
}
